import clsx from "clsx";
import LayoutDashboard from "layouts/layout-dashboard-collapse";
import { Link, useLocation } from "react-router-dom";
import { URLS } from "utils/constants";

const ProfileLayout = ({ children }) => {
    const location = useLocation();

    // Function to check if the link is active
    const isActive = (path) => {
        return location.pathname.startsWith(path) ? 'active' : '';
    }

    return (
        <LayoutDashboard>
            <div className="container-fluid mt-5">
                <div className="card rounded-2">
                    <div className="row g-0">
                        <div className="col-12 col-md-3 border-end">
                            <div className="card-body">
                                <h4 className="subheader">Account settings</h4>
                                <div className="list-group list-group-transparent">
                                    <Link to={URLS.v1.PROFILE} className={clsx("list-group-item list-group-item-action d-flex align-items-center", isActive(URLS.v1.PROFILE))}>My Account</Link>
                                    <Link to={URLS.v1.CHANGE_PASSWORD} className={clsx("list-group-item list-group-item-action d-flex align-items-center", isActive(URLS.v1.CHANGE_PASSWORD))}>Change Password</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-9 d-flex flex-column">
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </LayoutDashboard>
    );
};

export default ProfileLayout;
